import { FC } from "react";

import { FormInfobox, FormInfoboxProps } from "@/forms-design-system/FormInfobox/FormInfobox";
import { useTranslate } from "@/hooks/useTranslate";
import { Warning } from "@/icons/outlined";

type ThemedHelpZeffyCoverFeesInfoboxProps = Omit<FormInfoboxProps, "icon" | "title" | "description"> & {
  organizationName: string;
};

export const ThemedHelpZeffyCoverFeesInfobox: FC<ThemedHelpZeffyCoverFeesInfoboxProps> = ({
  organizationName,
  ...rest
}) => {
  const { t } = useTranslate();

  return (
    <FormInfobox
      icon={<Warning />}
      variant="emphasis"
      description={t("common", "payment.infoZeffyCoversFees", { orgName: organizationName })}
      {...rest}
    />
  );
};
